import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-guest-list',
  templateUrl: './guest-list.component.html',
  styleUrls: ['./guest-list.component.css']
})
export class GuestListComponent implements OnInit {

  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public swal: SweetAlert,
    public route: ActivatedRoute
  ) { }

  public guestData: any;
  public values: any = [];
  public editForm: boolean;
  public filterTable:boolean = true;
  public tableShow:boolean = false;
  public cols = [
    { key: '#', display:'#'},
    { key: 'name', display: 'Guest name',headerConfig:{ isDefault: true} },
    { key: 'userType', display: 'Guest type',headerConfig:{ isDefault: true} },
    { key: 'email', display: 'Email' },
    // { key: 'mobile', display: 'Mobile' },
    { key: 'location', display: 'Location' },
    { key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];
  ngOnInit() {
    this.getGuestList();
  }


  submitted(e: any) {
    console.log(e);
  }

  getGuestList() {
    this.tableShow = false;
    this.api.transportManagerGuestList({}).then((res: any) => {
      if (res.status == 'success') {
        this.guestData = res.data;
      }
      console.log(this.guestData)
      this.tableShow = true;
    }).catch((err) => {
      console.log(err);
    });
  }

  onActionHandler(e: any) {
    console.log(e);
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/guest/edit-guest',e.data.guestID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      console.log(e);
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor:  '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteGuestData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/guest/single-view-guest',e.data.guestID]);
    }
  }
  deleteGuestData(e?) {

    const obj = {
      guestID: e.data.guestID,
    };
    this.api.transportManagerGuestDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data == undefined || res.data ==''){
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.tableShow = true;
        this.getGuestList();
        }
        else{
          this.guestRouteRemovePopup(res.data);
        }
      } else {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  guestRouteRemovePopup(routes) {
    let fireContent = {
      title: 'Remove Guest from Assigned Route!',
      icon: 'warning',
    };
    if(routes.length > 0){
      let htmlContent = '';
      for(let r=0;r<routes.length;r++){
        if(routes[r].title) htmlContent += `<tr><td class="border-top-0">${r+1}</td><td class="border-top-0 text-left">${routes[r].title}</td></tr>`;
      }
      if(routes.length > 1) fireContent['title'] = 'Remove Guest from Assigned Routes!';
      fireContent['html'] = `<div class="row px-5"><div class="col-12 px-5" style="max-height:200px;overflow-y:auto;"><table class="table table-responsive table-sm">`+htmlContent+`</table></div></div>`;
      setTimeout(()=>{
        Swal.fire(fireContent);
      },300);
    }
  }
}
